import React from 'react';
import boy_listening_music from '../../../assets/images/telehealth/boy_listening_music.jpg';
import boy_mom from '../../../assets/images/telehealth/boy_mom.jpg';
import { motion } from 'framer-motion';

const TelehealthTherapy = () => {
  const TitleAndDescription = ({ title, description }) => {
    return (
      <div className="flex flex-col gap-1">
        <h2 className="text-[26px] sm:text-[28px] text-primary font-bold">
          {title}
        </h2>
        <p
          className="text-lg text-secondary font-light max-w-auto lg:max-w-[400px]"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    );
  };

  return (
    <section className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div className="mb-8">
        <h1 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold">
          Telehealth
        </h1>
        <h2 className="text-[30px] sm:text-[34px] md:text-[40px] text-primary font-bold">
          Therapy made easy
        </h2>
      </div>
      <div className="flex flex-col gap-10">
        <div className="flex flex-col md:flex-row gap-10 md:gap-20">
          <div className="flex-1 flex flex-col gap-4 sm:gap-10">
            <TitleAndDescription
              title="Embracing the Benefits of Telehealth for Pediatric Therapy"
              description="In recent years, telehealth has revolutionized the way we access healthcare services, and pediatric therapy is no exception. Through the power of technology, telehealth brings therapy sessions right into the homes of children and their families, offering convenience, accessibility, and meaningful support. We can help you explore the many benefits of telehealth for pediatric therapy and how it is transforming the landscape of child development services."
            />
            <TitleAndDescription
              title="Accessibility and Convenience"
              description="Telehealth eliminates the barriers of distance and travel, making therapy accessible to families regardless of their location. Remote sessions allow children in rural areas or areas with limited access to specialists to receive timely and high-quality care. Additionally, scheduling becomes more flexible, enabling parents to choose convenient appointment times that fit into their busy lives. "
            />
            <TitleAndDescription
              title="Comfort and Familiarity"
              description="By conducting therapy sessions in the familiar environment of a child's home, telehealth promotes a sense of comfort and security. This setting can help children feel at ease, leading to more effective and productive therapy sessions. The absence of the clinical environment may reduce anxiety and enhance engagement, resulting in better outcomes."
            />
            <TitleAndDescription
              title="Continuity of Care"
              description="Telehealth ensures a seamless continuity of care, even during unexpected events or disruptions. Illness, inclement weather, or other challenges that might otherwise interrupt therapy can be navigated with minimal impact. With telehealth, children can receive consistent therapy support, helping them maintain progress and momentum in their developmental journey."
            />
            <TitleAndDescription
              title="Specialist Access and Multidisciplinary Collaboration"
              description="Telehealth enables access to specialized pediatric therapists who may be located in different regions or have niche expertise. Children can benefit from the knowledge and experience of therapists who specialize in specific conditions or areas of development. Furthermore, telehealth facilitates seamless collaboration among multidisciplinary teams, such as speech therapists, occupational therapists, and psychologists, ensuring holistic care for the child."
            />
          </div>
          <div className="flex-1 flex flex-col gap-4 sm:gap-10">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src={boy_listening_music}
                alt="Child in virtual pediatric therapy session at home in Wasilla"
                className="rounded-3xl max-w-auto sm:max-w-[400px]"
              />
            </motion.div>
            <TitleAndDescription
              title="Comfort and Familiarity"
              description="By conducting therapy sessions in the familiar environment of a child's home, telehealth promotes a sense of comfort and security. This setting can help children feel at ease, leading to more effective and productive therapy sessions. The absence of the clinical environment may reduce anxiety and enhance engagement, resulting in better outcomes.
 "
            />
            <TitleAndDescription
              title="Parent Involvement and Collaboration"
              description="Telehealth allows parents to actively participate in their child's therapy sessions. They can observe, learn techniques, and actively engage in their child's progress. Therapists can provide guidance, offer real-time feedback, and suggest strategies that parents can implement during daily routines. This collaborative approach strengthens the parent-therapist partnership, fostering continued progress beyond the virtual sessions."
            />
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src={boy_mom}
                alt="Parent and child in Wasilla therapy consultation"
                className="rounded-3xl max-w-auto sm:max-w-[400px]"
              />
            </motion.div>
            <TitleAndDescription
              title="Parent Education and Coaching"
              description="Through telehealth, therapists can provide parents with valuable education and coaching on various topics related to their child's development. This may include strategies for behavior management, creating supportive home environments, or implementing therapeutic activities between sessions. Empowering parents with knowledge and skills enhances their ability to support their child's progress."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TelehealthTherapy;
